import React from "react";
import {LookDataType} from "./LookTypes";

const TitleBlock: React.FC<{look: LookDataType; isMobile: boolean; isLookDetailPageItem?: boolean}> = ({
  isMobile,
  look,
  isLookDetailPageItem = true,
}) => {
  return (
    <>
      {isLookDetailPageItem ? (
        <h1 className="title">{look.title.toUpperCase()}</h1>
      ) : (
        <h2 className="title tablet-small-hide">{look.title.toUpperCase()}</h2>
      )}
      <span className={`${isMobile ? "mobile-" : ""}creator-section`}>
        <img src={look.creator.image || undefined} className="creator-image" alt={look.creator.name} />
        {isLookDetailPageItem ? (
          <div className="creator-name">{look.creator.name}</div>
        ) : (
          <div className="stl-text-container">
            <h3 className="title max-tablet">{look.title}</h3>
            <span className="thumb-creator-name">{look.creator.name}</span>
          </div>
        )}
      </span>
    </>
  );
};

export default TitleBlock;
